import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Supplier
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	all(callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/basicInfo/all`, callback);
	}

	byId(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/id/${id}`, callback)
	}

	address(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${id}/address`, callback);
	}

	contactInfo(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${id}/contactInfo`, callback);
	}

	thresholdAmount(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${id}/thresholdAmount`, callback);
	}

	feesAndDiscount(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${id}/feeAndDiscount`, callback);
	}

	apiCredentials(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${id}/apiCredentials`, callback);
	}

	priorityForBrand(brandId, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.priority}/brand/${brandId}`, callback)
	}

	brands(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.brand}/catalog/supplier/${id}`, callback);
	}

	supplierBrands(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.brand}/catalog/id/${id}`, callback);
	}

	download(id, callback) {
		this.backend.callBackend(`${Endpoints.catalog.download.private}/${id}`, callback,'GET');
	}

	cards(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.card}/supplier/${id}`, callback);
	}

	cardsByBrandBySupplier(supplierId, supplierBrandId, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.card}/supplier/${supplierId}/supplierBrand/${supplierBrandId}`, callback);
	}
   
	layout(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.layout}/${id}`, callback);
	}

	bestSuppliers(callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/best/all`, callback)
	}
	allBrandsWithBestSupplier(callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/brands/all/best-supplier`, callback)
	}
	bestRateForBrand(brandId, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/best/${brandId}`, callback);
	}
	bestRateForPurchaserBrand(purchaserId, brandId, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.brand}/bestBrands/${purchaserId}/${brandId}`, callback);
	}
	cardCatalog(callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.cardCatalog}`, callback);
	}

	cardCatalogBySupplier(supplierId, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.cardCatalog}/supplier/${supplierId}`, callback);
	}

	supplierItem(sku, supplierId, callback)
	{
	
		this.backend.callBackend(`${Endpoints.supplier.cardCatalog}/sku/${sku}/supplier/${supplierId}`, callback);
	}

	add(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/basicInfo`, callback, "POST", data);
	}

	addAddress(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/address`, callback, "POST", data);
	}

	addContactInfo(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/contactInfo`, callback, "POST", data);
	}

	addThresholdAmount(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/thresholdAmount`, callback, "POST", data);
	}

	addFeeAndDiscount(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/feeAndDiscount`, callback, "POST", data);
	}

	addApiCredentials(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/apiCredentials`, callback, "POST", data);
	}

	addBrand(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.brand}`, callback, "POST", data);
	}

	addCard(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.card}`, callback, "POST", data);
	}

	addLayout(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.layout}`, callback, "POST", data);
	}

	addCardtoCatalog(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.cardCatalog}`, callback, "POST", data);
	}

	setSupplierPriority(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.priority}`, callback, "POST", data)
	}

	update(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/${data.id}/basicInfo`, callback, "PUT", data);
	}

	updateEDT(supplierId, edt, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/id/${supplierId}/etd/${edt}`, callback, "PUT")
	}

	updateAddress(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/address`, callback, "PUT", data);
	}

	updateContactInfo(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/contactInfo`, callback, "PUT", data);
	}

	updateThresholdAmount(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/thresholdAmount`, callback, "PUT", data);
	}

	updateFeeAndDiscount(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/feeAndDiscount`, callback, "PUT", data);
	}

	updateApiCredentials(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/apiCredentials`, callback, "PUT", data);
	}

	updateBrand(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.brand}`, callback, "PUT", data);
	}

	updateCard(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.card}`, callback, "PUT", data);
	}

	updateLayout(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.layout}`, callback, "PUT", data);
	}

	updateSupplierPriority(data, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.priority}`, callback, "PUT", data)
	}

	remove(id, callback)
	{
		this.backend.callBackend(`${Endpoints.supplier.private}/id/${id}`, callback, "DELETE");
	}

	getPurchaserOrderById(supplierId, callback)
	{
		this.backend.callBackend(`${Endpoints.purchaseOrder.supplier}/${supplierId}`, callback);
	}

	addPurchaserOrder(data, callback)
	{
		this.backend.callBackend(`${Endpoints.purchaseOrder.supplier}/add`, callback, "POST", data);
	}

	removePurchaserOrderById(id, callback)
	{
		this.backend.callBackend(`${Endpoints.purchaseOrder.supplier}/delete/${id}`, callback, "DELETE");
	}
	
	createPurchaserOrderByName(name,orderReference, callback) 
	{
		this.backend.callBackend(`${Endpoints.purchaseOrder.supplier}/purchase-order`, callback, 'POST',{ name,orderReference });
	}

	uploadFile(file, info, callback)
	{
		const data = new FormData();
		data.append('file', file);
		data.append("info", Backend.wrapJSONBody(info));
		this.backend.callBackend(`${Endpoints.supplier.file}/upload`, callback, "POST", data, false);
	}

	getAllSuppliersByBrand (brandId, callback) {
		this.backend.callBackend(`${Endpoints.supplier.private}/all/brand/${brandId}`, callback)
	}
	uploadSupplierBrand(id, data, callback) {
		this.backend.callBackend(`${Endpoints.supplier.brand}/upload/${id}`, callback, 'POST', data , false)
	  }
	  
	  downloadSupplierBrand(id, callback, data) {
		this.backend.callBackend(`${Endpoints.supplier.brand}/download/${id}`, callback, "GET")
	  }
	  batchManage(data,callback){
		this.backend.callBackend(`${Endpoints.brand.inventory}/whitelist-brand/manageBatch`, callback, 'POST', data )
	  }
	  createFund(data,callback){
		this.backend.callBackend(`${Endpoints.supplier.private}/funds-alerts`, callback, "POST", data);
	  }
	  getFundDetails(id,callback){
		this.backend.callBackend(`${Endpoints.supplier.private}/funds-alerts/${id}`, callback, "GET");
	  }
	  deleteFund(id,callback){
		this.backend.callBackend(`${Endpoints.supplier.private}/funds-alerts/${id}`, callback, "DELETE");
	  }
}